import React, { Component } from 'react';
import { Row, Col, Modal, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import Messages from '../chat/messages';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

class InteractionMessagesModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} size="lg">
                    <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                        <Modal.Header>
                            <Modal.Title>
                                {
                                    (this.props.interaction) &&
                                    <Row>
                                        <Col lg={3}>
                                            <div className={`icon ${this.props.interaction.channel.toLowerCase()}`} style={{ "left": "0px", "top": "5px" }} ></div>
                                        </Col>
                                        <Col lg={9}>
                                            <div >{this.props.interaction.group}</div>
                                            <div >{this.props.interaction.name}</div>
                                        </Col>
                                    </Row>
                                }
                            </Modal.Title>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("close")}
                                </Tooltip>}>
                                <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                            </OverlayTrigger>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    <Messages interaction={this.props.interaction} addMessageRef={e => { }} lastMessage={null} />
                                </Col>
                            </Row>
                        </Modal.Body>
                    </BlockUi>
                </Modal>
            </>)
    }
}

export default withTranslation()(InteractionMessagesModal);